'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deferMiddleware;
/* eslint-disable no-unused-vars */

function deferMiddleware() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var middleware = function middleware(next) {
    return function (req) {
      return next(req);
    };
  };

  middleware.supports = ['defer'];

  return middleware;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-relay-network-layer/lib/middleware/defer.js
// module id = 1511
// module chunks = 0